import { Grid, Tooltip, Typography } from "@mui/material"
import { ProgressWheel, StyledPaper } from "."
import { displayNumber } from "./utils"

export interface StatsBoxType {
  title: string
  content: string | number
  subContent?: string | number
  type: 'dollar' | 'percent' | 'number' | 'string'
  style?: any
  progressWheel?: number
  minDecimals?: number
  tooltip?: string
  subContentType?: 'dollar' | 'percent' | 'number' | 'string'
}

const StatsBox = (props: StatsBoxType) => {
  const { title, type, content, subContent, style, progressWheel, minDecimals, tooltip, subContentType } = props

  const parseContent = (content: string | number, type: string) => {
    const prefix = type === 'dollar' ? '$' : ''
    const suffix = type === 'percent' ? '%' : ''
    const displayDecimal = type === 'number' ? 6 : 2
    return `${prefix}${type === 'string' ? content : displayNumber(Number(content), displayDecimal, minDecimals)}${suffix}`
  }

  return (
    <Grid item container>
      <StyledPaper color='primary' sx={{
        // // backgroundColor: '#283D3E', 
        padding: { xs: '0.5rem 1rem', sm: '1rem 1.5rem' },
        minWidth: { xs: '8.7rem', sm: '12.8rem' },
        maxWidth: { xs: '100%', sm: '100%' },
        minHeight: { xs: '5rem', sm: '6rem' },
        width: '100%',
        borderRadius: 1,
        ...style
      }}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
          <Grid item container flexDirection={'column'} gap={1} xs={progressWheel ? 6 : 12}>
            <Tooltip title={tooltip} content={tooltip as string}>
              <Typography variant={'xs'} color='text.secondary' sx={{
                textDecoration: tooltip ? 'underline dotted' : 'none',
                textUnderlineOffset: 4,
                textWrap: 'nowrap',
                cursor: tooltip ? 'pointer' : 'auto'
              }}>
                {title}
              </Typography>
            </Tooltip>
            <Typography variant='xl' color='text.primary'>
              {parseContent(content, type)}
            </Typography>
            {
              (subContent || subContent === 0) && (
                <Typography variant='s' color='text.secondary' sx={{ marginTop: '-0.75rem' }}>
                  {parseContent(subContent, subContentType ?? type)}
                </Typography>
              )
            }
          </Grid>
          {
            progressWheel && (
              <Grid item xs={5} sx={{ textAlign: 'right' }}>
                <ProgressWheel value={progressWheel} size={70} />
              </Grid>
            )
          }
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default StatsBox